import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M.184 12.582H4.66q.528 0 .75-.164.223-.165.352-.469l1.476-3.597 2.73 8.73a.6.6 0 0 0 .4.422q.315.105.62-.012a.67.67 0 0 0 .422-.445l1.418-4.465h2.766q.363 0 .55-.164.189-.165.317-.469l1.547-3.597 2.719 8.73q.105.317.41.422.316.105.62-.012a.67.67 0 0 0 .423-.445l1.418-4.465h4.218V11.07h-4.64q-.352 0-.551.164-.2.165-.316.47l-.868 2.448-2.73-8.25a.6.6 0 0 0-.387-.422.83.83 0 0 0-.597.012q-.305.105-.446.446l-2.11 5.132h-2.753q-.364 0-.562.164-.2.165-.305.47l-.88 2.448-2.718-8.25a.63.63 0 0 0-.398-.422.83.83 0 0 0-.598.012q-.305.105-.445.446L4.414 11.07H.184zm3.68 9.75q-1.841 0-2.766-.914-.915-.903-.914-2.707V4.39q0-1.817.914-2.72.926-.913 2.765-.913h20.274q1.851 0 2.765.914.915.915.914 2.719v14.32q0 1.804-.914 2.707-.913.915-2.765.914z"
    }, null, -1)
  ]))]))
}
export default { render: render }